import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Credits page now redirects to Settings > Credits section
// All credit management has been consolidated there
const Credits = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/settings?section=credits', { replace: true });
  }, [navigate]);

  return null;
};

export default Credits;
